import { render, staticRenderFns } from "./BaseTable.vue?vue&type=template&id=97d80212&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=ts"
export * from "./BaseTable.vue?vue&type=script&lang=ts"
import style0 from "./BaseTable.vue?vue&type=style&index=0&id=97d80212&prod&lang=scss&scoped=true"
import style1 from "./BaseTable.vue?vue&type=style&index=1&id=97d80212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d80212",
  null
  
)

export default component.exports